<template>
    <div
        class="flex flex-col md:flex-row bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 overflow-hidden relative col-span-12"
    >
        <!-- Mobile Image (top) -->
        <div class="md:hidden w-full">
            <img
                src="../../../../images/10xplus-banner-card-mobile.png"
                alt="Upgrade to 10xTravel+"
                class="w-full h-auto"
            />
        </div>

        <!-- Content -->
        <div
            class="flex flex-col gap-6 md:gap-8 py-6 px-6 md:px-12 md:w-[670px] z-10"
        >
            <div class="flex flex-col w-full max-w-[572px]">
                <!-- Premium Badge (desktop only) -->
                <div class="pb-4 hidden md:block">
                    <span
                        class="inline-flex items-center gap-2 pl-2 pr-3 py-1 rounded-full border border-orange-200"
                    >
                        <icon icon="star" class="w-4 h-4 text-10x-orange" />
                        <span class="text-sm font-medium text-10x-orange">
                            Premium
                        </span>
                    </span>
                </div>

                <!-- Title -->
                <div class="flex flex-col gap-2 pb-6">
                    <h2 class="text-2xl font-semibold text-slate-800 dark:text-slate-100">
                        Upgrade to
                        <span class="text-10x-orange">10xTravel+</span>
                    </h2>
                    <p class="text-sm text-slate-500">
                        Get more from your rewards with automated tools and
                        travel experts
                    </p>
                </div>

                <!-- Features List (single column on mobile, two columns on desktop) -->
                <div class="flex flex-col md:flex-row gap-3 md:gap-6">
                    <!-- Left Column -->
                    <div class="flex flex-col gap-3 md:gap-4 flex-1">
                        <div class="flex items-center gap-2">
                            <icon
                                icon="groups"
                                class="w-5 h-5 text-10x-orange shrink-0"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                Travel community
                            </span>
                        </div>
                        <div class="flex items-center gap-2">
                            <icon
                                icon="coin"
                                class="w-5 h-5 text-10x-orange shrink-0"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                Unlimited benefits tracker
                            </span>
                        </div>
                        <div class="flex items-center gap-2">
                            <icon
                                icon="mail"
                                class="w-5 h-5 text-10x-orange shrink-0"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                Import redemptions
                            </span>
                        </div>
                    </div>

                    <!-- Right Column -->
                    <div class="flex flex-col gap-3 md:gap-4 flex-1">
                        <div class="flex items-center gap-2">
                            <icon
                                icon="bell"
                                class="w-5 h-5 text-10x-orange shrink-0"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                Award alerts
                            </span>
                        </div>
                        <div class="flex items-center gap-2">
                            <icon
                                icon="card-check"
                                class="w-5 h-5 text-10x-orange shrink-0"
                            />
                            <span class="text-sm text-slate-800 dark:text-slate-100">
                                Best cards to use
                            </span>
                        </div>
                        <div
                            v-if="transferBonusAlertsEnabled"
                            class="flex items-center gap-2"
                        >
                            <Icon
                                icon="transfer-partners"
                                class="w-5 h-5 text-10x-orange shrink-0"
                            />
                            <span class="text-sm text-slate-800">
                                Transfer bonus alerts
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Buttons (stacked on mobile, inline on desktop) -->
            <div
                class="flex flex-col md:flex-row items-stretch md:items-start gap-3 md:gap-4"
            >
                <a
                    :href="upgradeUrl"
                    class="inline-flex items-center justify-center px-4 py-3 md:py-2.5 bg-10x-orange text-white text-sm font-medium rounded-lg md:rounded shadow-sm hover:bg-orange-600 transition-colors"
                >
                    Upgrade
                </a>
                <a
                    :href="learnMoreUrl"
                    class="inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2.5 text-sm font-medium text-slate-800 dark:text-slate-100 hover:text-slate-600 transition-colors"
                >
                    Learn more
                </a>
            </div>
        </div>

        <!-- Right Illustration (desktop only) -->
        <div
            class="absolute right-0 top-0 bottom-0 overflow-hidden hidden md:block"
        >
            <img
                src="../../../../images/10xplus-banner-card.png"
                alt="Upgrade to 10xTravel+"
                class="object-cover w-full h-full"
            />
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

const { transferBonusAlertsEnabled } = useFeatureFlags();

const upgradeUrl = '/10xtravel-plus/upgrade';
const learnMoreUrl = '/10xtravel-plus';
</script>
